// Simple toast notification utility
class ToastManager {
  constructor() {
    this.toasts = [];
    this.listeners = [];
  }

  show(message, type = 'success', duration = 3000) {
    const id = Date.now();
    const toast = { id, message, type };
    this.toasts.push(toast);
    this.notifyListeners();

    // Auto remove after duration
    setTimeout(() => {
      this.remove(id);
    }, duration);

    return id;
  }

  success(message, duration) {
    return this.show(message, 'success', duration);
  }

  error(message, duration) {
    return this.show(message, 'error', duration || 5000);
  }

  remove(id) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
    this.notifyListeners();
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  notifyListeners() {
    this.listeners.forEach((listener) => listener(this.toasts));
  }

  clear() {
    this.toasts = [];
    this.notifyListeners();
  }
}

export const toast = new ToastManager();




// WEBPACK FOOTER //
// ./src/utils/toast.js